import useReveal from "../hooks/useReveal";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { BRAND } from "../lib/data";

export default function Contact() {
  useReveal();
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(BRAND.address)}&output=embed`;

  return (
    <div data-testid="contact-page" className="pt-28 pb-24 bg-[#0B0B0B] text-white">
      <section className="px-6 md:px-12 py-16 text-center">
        <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">Get In Touch</span>
        <h1 className="font-display text-5xl md:text-6xl mt-5">Visit The Salon</h1>
        <p className="text-white/65 max-w-2xl mx-auto mt-5 text-sm md:text-base">We'd love to see you — pop in, call, or send us a note.</p>
      </section>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5 space-y-6">
          <ContactCard icon={MapPin} title="Address" lines={[BRAND.address]} />
          <ContactCard icon={Phone} title="Phone" lines={[BRAND.phone]} href={`tel:${BRAND.phone}`} />
          <ContactCard icon={Mail} title="Email" lines={[BRAND.email]} href={`mailto:${BRAND.email}`} />
          <ContactCard
            icon={Clock}
            title="Opening Hours"
            lines={["Mon – Fri • 9:00 – 18:30", "Saturday • 9:00 – 19:00", "Sunday • 10:00 – 17:00"]}
          />
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="rounded-3xl overflow-hidden border border-[#C9A34E]/25 aspect-[4/3] lg:aspect-auto lg:h-full min-h-[420px]">
            <iframe
              data-testid="google-map"
              title="Enrich Hair & Beauty location"
              src={mapSrc}
              className="w-full h-full"
              style={{ border: 0, filter: "grayscale(0.4) contrast(1.05)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ContactCard({ icon: Icon, title, lines, href }) {
  const Content = (
    <div className="reveal bg-[#141414] border border-[#C9A34E]/20 hover:border-[#C9A34E]/55 transition-colors rounded-2xl p-7 flex gap-5">
      <div className="w-12 h-12 rounded-full bg-[#C9A34E]/10 border border-[#C9A34E]/30 flex items-center justify-center text-[#C9A34E] shrink-0">
        <Icon size={20} />
      </div>
      <div>
        <p className="text-[11px] tracking-[0.28em] uppercase text-[#C9A34E]">{title}</p>
        <div className="mt-2 space-y-1 text-sm text-white/80">
          {lines.map((l) => <p key={l}>{l}</p>)}
        </div>
      </div>
    </div>
  );
  return href ? (<a href={href} className="block">{Content}</a>) : Content;
}
